module.exports = __webpack_public_path__ + "img/solusi-organik-indonesia.9a5c30a8.png";